import React, { useState, useRef, useEffect } from "react";
import "./CustomComponentStyles.css";
import CloseIcon from "@material-ui/icons/Close";

const ChecklistDropdown = ({
  options,
  selectedOptions,
  onSelect,
  placeholder,
  isLoading,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleOptionClick = (option) => {
    const isSelected = selectedOptions.some((item) => item.id === option.id);
    if (isSelected) {
      onSelect(selectedOptions.filter((item) => item.id !== option.id));
    } else {
      onSelect([...selectedOptions, option]);
    }
  };

  const handleRemoveOption = (option) => {
    onSelect(selectedOptions.filter((item) => item.id !== option.id));
  };

  const handleClearAll = (e) => {
    e.stopPropagation();
    onSelect([]);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="dropdown-cust-container" ref={dropdownRef}>
      <div className="dropdown-cust" onClick={() => setIsOpen(!isOpen)}>
        {isLoading ? (
          <span>Loading...</span>
        ) : selectedOptions.length > 0 ? (
          <div className="selected-options-wrapper">
            <div className="selected-options">
              {selectedOptions.map((option) => (
                <div key={option.id} className="selected-option">
                  <span>{option.title_text}</span>
                  <CloseIcon
                    className="close-icon"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleRemoveOption(option);
                    }}
                  />
                </div>
              ))}
            </div>

            <CloseIcon className="clear-all-icon" onClick={handleClearAll} />
          </div>
        ) : (
          <span>{placeholder}</span>
        )}
      </div>
      {isOpen && !isLoading && (
        <div className="dropdown-cust-list">
          {options.map((option) => (
            <div
              key={option.id}
              className="dropdown-cust-item"
              onClick={() => handleOptionClick(option)}
            >
              <input
                type="checkbox"
                checked={selectedOptions.some((item) => item.id === option.id)}
                readOnly
              />
              <span>{option.title_text}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ChecklistDropdown;
